import { AspectRatio as ChakraAspectRatio } from "@chakra-ui/react";

export const AspectRatio = ChakraAspectRatio;
